import {
  FETCH_COUNTRY_SUCCESS_ACTION,
  FETCH_CURRENCY_SUCCESS_ACTION,
  FETCH_CNTRY_CRNCY_SUCCESS_ACTION,
} from "./action";

const initialState = {
  processing: false,
  error: false,
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_COUNTRY_SUCCESS_ACTION:
      return {
        ...state,
        CountrysList: action.payload.rows,
      };

    case FETCH_CURRENCY_SUCCESS_ACTION:
      return {
        ...state,
        CurrencyList: action.payload.rows,
      };

    case FETCH_CNTRY_CRNCY_SUCCESS_ACTION:
    
      return {
        ...state,
        cntrycrncyList: action.payload.rows,
        cntrycrncyListCount: action.payload.count,
      };

    default:
      return {
        ...state,
      };
  }
}
